import styled from 'styled-components';

import Drawer from '@material-ui/core/Drawer';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import { borderColor, mainColor, sectionColor } from '../../../lib/theme';

export const PANEL_WIDTH = 560;
// Expanded fills the viewport — a full-screen modal over the app (the drawer
// paper is already full-height, so 100vw width makes it cover the screen).
export const EXPANDED_PANEL_WIDTH = '100vw';

// Width is applied per-render via the Drawer's PaperProps (it flips between
// PANEL_WIDTH and EXPANDED_PANEL_WIDTH); withStyles only owns the static chrome.
export const StyledDrawer = withStyles({
  paper: {
    maxWidth: '100vw',
    background: '#fff'
  }
})(Drawer);

export const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid ${borderColor};
  background: ${sectionColor};
`;

export const HeaderTitle = styled(Typography)`
  && {
    font-weight: 600;
    flex-shrink: 0;
  }
`;

export const HeaderSpacer = styled.div`
  flex-grow: 1;
  min-width: 0;
`;

export const StyledTabs = withStyles({
  root: {
    borderBottom: `1px solid ${borderColor}`,
    minHeight: 44
  },
  indicator: {
    backgroundColor: mainColor,
    height: 3
  }
})(Tabs);

export const StyledTab = withStyles({
  root: {
    textTransform: 'none',
    fontSize: 14,
    fontWeight: 500,
    minHeight: 44,
    minWidth: 120,
    fontFamily: 'Quicksand, sans-serif'
  }
})(Tab);

export const Body = styled.div`
  flex-grow: 1;
  overflow-y: auto;
`;
